import {
  HttpErrorResponse,
  HttpInterceptorFn,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuditService } from "../services/audit.service";
import { environment } from "../../environments/environment";

export const auditHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const audit = inject(AuditService);
  const base = environment.apiBaseUrl.replace(/\/$/, "");
  const urlNoQuery = req.url.split("?")[0] ?? req.url;

  const isApiCall = urlNoQuery.startsWith(base);
  const isAuditIngest =
    urlNoQuery === `${base}/auditevents/batch` ||
    urlNoQuery.endsWith("/auditevents/batch");
  const isLogin =
    urlNoQuery.endsWith("/auth/admin-login") ||
    urlNoQuery.includes("/auth/admin-login");
  const path = isApiCall ? urlNoQuery.slice(base.length) : "";
  const method = String(req.method || "").toUpperCase();

  const isInstrumentedAdminCrud =
    ["POST", "PUT", "PATCH", "DELETE"].includes(method) &&
    [
      "/users",
      "/violations",
      "/enrollments",
      "/courses",
      "/schedules",
      "/payment-methods",
      "/paymentmethods",
      "/locations",
      "/serialnumbers",
      "/reminder-configurations",
      "/communication",
    ].some((p) => path === p || path.startsWith(`${p}/`));

  return next(req).pipe(
    catchError((err: unknown) => {
      if (isApiCall && !isAuditIngest && !isLogin && err instanceof HttpErrorResponse) {
        if (isInstrumentedAdminCrud) {
          return throwError(() => err);
        }
        if (audit.shouldSuppressHttpErrorAudit()) {
          return throwError(() => err);
        }
        const safeUrl = urlNoQuery.slice(0, 500);
        audit.trackAction(
          "API_ERROR",
          "http_error",
          {
            request: { method: req.method, url: safeUrl },
            response: { status: err.status, statusText: err.statusText },
            error: {
              message:
                (err.error && (err.error.message || err.error.title)) ||
                (typeof err.error === "string" ? err.error : "") ||
                err.message ||
                "HTTP error",
            },
          },
          true,
        );
      }
      return throwError(() => err);
    }),
  );
};
